import React from "react";
import { BookOpenIcon, CalendarDaysIcon, ClipboardCheckIcon, ClipboardListIcon, DumbbellIcon, FileTextIcon, ListChecksIcon, PuzzleIcon, Table2Icon, UsersIcon, BoxIcon } from "lucide-react";
import { interiorPages, PageVariant } from "../../data/content";
const variantIcon: Record<PageVariant, BoxIcon> = {
  exercise: DumbbellIcon,
  routine: ListChecksIcon,
  checklist: ClipboardCheckIcon,
  table: Table2Icon,
  cognitive: PuzzleIcon,
  calendar: CalendarDaysIcon,
  card: FileTextIcon,
  guide: BookOpenIcon,
  planner: ClipboardListIcon,
  group: UsersIcon
};
export function InteriorPages() {
  return <section className="bg-brand-600 py-8 text-white lg:py-12" aria-labelledby="interior-title" data-id="element-322" data-mp="3d4u6c4nbyjlt">
      <div className="mx-auto max-w-5xl px-5" data-id="element-323" data-mp="3h4uj7kus6mqr">
        <div className="mx-auto max-w-2xl text-center" data-id="element-324" data-mp="3h3jffl1c5ezn">
          <h2 id="interior-title" className="font-display text-[21px] font-extrabold leading-tight tracking-tight sm:text-3xl" data-id="element-325" data-mp="8ornmdgy0ois">
            No son solo libros. <span className="text-brand-100 underline decoration-sun decoration-[3px] underline-offset-[6px]" data-id="element-326" data-mp="dids3icydm3i">Es una preparación con recursos para usar.</span>
          </h2>
          <p className="mt-2.5 text-[13px] font-semibold leading-snug text-white sm:text-base" data-id="element-327" data-mp="3dq3qa9fv2oms">
            Herramientas pensadas para ayudarte a preparar, planificar y aplicar tus sesiones.
          </p>
        </div>

        <ul className="mx-auto mt-5 grid max-w-3xl grid-cols-2 gap-2 sm:grid-cols-3 lg:mt-7 lg:gap-2.5" data-id="element-328" data-mp="3nklvxk4u8u98">
          {interiorPages.map(p => {
          const Icon = variantIcon[p.variant];
          return <li key={p.label} className="flex items-center gap-2.5 rounded-xl bg-white/10 px-3 py-2.5 ring-1 ring-white/15" data-id="element-329" data-mp="196ub97e9j51">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white text-brand-600" data-id="element-330" data-mp="a8204k6j0r7t">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-331" data-mp="2gxgmjpq9uqd8" />
                </span>
                <span className="min-w-0 flex-1 font-display text-[13px] font-bold leading-tight text-white sm:text-sm" data-id="element-332" data-mp="2bzotgsdw4y7g">{p.label}</span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}